import * as z from "zod";
import type { Ctx } from "../../types";
import { FormAction, invalidate, setQueryParams } from "gg-wf-scripts";
import {
  array_field,
  invokeApi,
  notification_fields_shape,
  nullable_field,
  parse,
  role_enum,
} from "../_helpers";

const bonus_count_field = z.preprocess(
  (v) => (v === "" || v == null ? undefined : v),
  z.coerce
    .number("Bonus count must be a number")
    .int("Bonus count must be a whole number")
    .min(0, "Bonus count cannot be negative")
    .optional()
);

const update_profile_schema = z
  .object({
    first_name: nullable_field(z.string()),
    last_name: nullable_field(z.string()),
    phone: nullable_field(z.string()),
    avatar_url: nullable_field(z.url("Avatar URL is not a valid URL")),
    role: role_enum,
    schools: array_field(z.uuid("Please select valid Schools")),
    bonus_count: bonus_count_field,
    ...notification_fields_shape,
  })
  .refine((d) => d.role !== "school_admin" || d.schools.length > 0, {
    path: ["schools"],
    message: "Please select at least one School",
  });

export const update_profile: FormAction<Ctx> = async (
  { sb },
  formData,
  params
) => {
  const user_id = params.get("id");
  if (!user_id) return { ok: false, error: "Missing id in URL" };

  const parsed = parse(update_profile_schema, formData);
  if (!parsed.ok) return parsed;

  const result = await invokeApi(sb, `api/users/${user_id}`, {
    method: "PUT",
    body: parsed.data,
  });
  if (!result.ok) return result;
  invalidate("users");
  setQueryParams([{ key: "modal", value: "view" }]);
  return result;
};
